module.exports = __webpack_public_path__ + "img/undraw_welcome_3gvl.f81d4805.svg";